import { render, staticRenderFns } from "./vue2-slider.vue?vue&type=template&id=1beb6874"
import script from "./vue2-slider.vue?vue&type=script&lang=js"
export * from "./vue2-slider.vue?vue&type=script&lang=js"
import style0 from "./vue2-slider.vue?vue&type=style&index=0&id=1beb6874&prod&lang=css"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports